import { useState, type ReactNode } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

import { Card } from '@/components/ui/Card';

/**
 * Right-rail widget SLOT for the ticket detail page (Phase 16 / ADR-026,
 * spec §3.7). These are deliberate structural stubs — the spec requires
 * the slots to exist now so the CS-Phase 5 live widgets (order lookup,
 * shipment tracking, Kaerwell Connect) land in reserved space instead
 * of reflowing the page. Do not delete them as "placeholders".
 */
export function WidgetSlotCard({ title, children }: { title: string; children?: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <Card className="p-0">
      <button
        type="button"
        onClick={() => {
          setOpen((v) => !v);
        }}
        aria-expanded={open}
        className="flex w-full items-center justify-between px-4 py-3 text-left"
      >
        <span className="text-[13px] font-medium text-kw-shark">{title}</span>
        {open ? (
          <ChevronDown className="size-4 text-kw-muted" />
        ) : (
          <ChevronRight className="size-4 text-kw-muted" />
        )}
      </button>
      {open ? (
        <div className="border-t border-kw-border px-4 py-3">
          {children ?? (
            <p className="text-[12px] text-kw-muted">
              Live data lands here in CS-Phase 5. This slot is reserved so the layout doesn&apos;t shift when
              it does.
            </p>
          )}
        </div>
      ) : null}
    </Card>
  );
}
